import React from 'react';


export default ({rows}) => {
  if (rows.length === 0) {
    return <div className='alert alert-warning'>Report is empty.</div>;
  }
  return (
    <table className='table' width='100%'>
      <thead>
        <tr>
          <th>Date/Time</th>
          <th>Device</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        {
          rows.map((r, i) => (
            <tr key={i}>
              <td>{r.ts}</td>
              <td>{r.device_name}</td>
              <td>{r.description}</td>
            </tr>
          ))
        }
      </tbody>
    </table>
  );
}
